import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const ppiCalculatorTool: Tool = {
  id: "ppi-calculator",
  name: () => m.ppi_tool_name(),
  description: () => m.ppi_tool_description(),
  icon: "🖥️",
  basePath: "/ppi-calculator",
  status: "stable",
  tags: ["design", "screen", "display", "ppi-calculator"],
};
